import {ReactNode} from 'react';
import styles from './styles.module.less';
import {useCollapse} from '../use-collapse';
import {join} from '../../utils';
import {ArrowIcon} from '../../icons';

interface CollapseProps {
	children: ReactNode;
	title: string;
	className?: string;
	contentClassName?: string;
}

export function Collapse({children, title, className, contentClassName}: CollapseProps) {
	const [collapseProps, collapsed, toggle] = useCollapse();
	return (
		<div className={join(styles.collapse, className)}>
			<div className={styles.title} onClick={() => toggle(!collapsed)}>
				<ArrowIcon direction={collapsed ? 'up' : 'down'}/>
				<div className={styles.titleText}>{title}</div>
			</div>
			<div {...collapseProps} className={contentClassName}>{children}</div>
		</div>
	);
}
